import { profilePinAuthority } from "../../utils/profileAccess";
import React, { useContext, useEffect, useRef, useState } from "react";
import {
  addProfile,
  deleteProfile,
  getProfileAvatarsApi,
  getProfileInfo,
  getProfilesApi,
  updateProfile
} from "../../api/user/user";
import localizationStrings from "../../statics/localization";
import { SessionContext } from "../../context/SessionContext";
import Notification from "../notification/Notification";
import { sendCustomProfileReport } from "../../utils/reporting/customReporting";
import addProfileIcon from "../../assets/images/add-profile-button.png";
import ProfileEditIcon from "../../assets/icons/svg/ProfileEditIcon";
import TvLockIcon from "../../assets/icons/svg/TvLockIcon";
import { useHistory, useParams } from "react-router-dom";
import { getMainboards } from "../../api/vod/vod";
import mainLogo from "../../assets/logo/atlas-logo.png";
import useQuery from "../../utils/useQuery";
import { normalizeApiText } from "../../utils/charset";
import { isFirefox } from "react-device-detect";
import firefoxPinSecret from "../../utils/firefoxPinSecret";
import SwitchButton from "../switchButton/SwitchButton";
import ArrowRightIcon from "../../assets/icons/svg/ArrowRightIcon";
import ArrowLeftIcon from "../../assets/icons/svg/ArrowLeftIcon";
import { getProfileCopy } from "./profileCopy";
import CinemaIcon from "../cinema/CinemaIcon";

const ProfileSettings = () => {
  const copy = getProfileCopy();
  useEffect(() => {
    document.body.classList.add("atlas-profiles-open");
    return () => document.body.classList.remove("atlas-profiles-open");
  }, []);
  const [isCreating, setIsCreating] = useState(false);
  const createPending = useRef(false);
  const [profileName, setProfileName] = useState("");
  const [selectedProfile, setSelectedProfile] = useState(null);
  const [selectedAvatar, setSelectedAvatar] = useState(null);
  const [focusedAvatar, setFocusedAvatar] = useState(null);
  const [isChildProfile, setIsChildProfile] = useState(false);
  const [avatars, setAvatars] = useState([]);
  const [password, setPassword] = useState("");
  const [secondPassword, setSecondPassword] = useState("");
  const [showNotification, setShowNotification] = useState(false);
  const [showRemovePasswordNotification, setShowRemovePasswordNotification] =
    useState(false);
  const [notificationText, setNotificationText] = useState("");
  const [showAvatars, setShowAvatars] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [showProfileNameAlert, setShowProfileNameAlert] = useState(false);
  const [profileAvatar, setProfileAvatar] = useState(addProfileIcon);
  const [hasPassword, setHasPassword] = useState(false);
  const [i, setI] = useState(0);
  const [secondI, setSecondI] = useState(0);
  const [existingPin, setExistingPin] = useState("");
  const [pinText, setPinText] = useState("");
  const [secondPinText, setSecondPinText] = useState("");
  const [showDeleteNotification, setShowDeleteNotification] = useState(false);
  const {
    userFrameConfig,
    profile,
    profileInfo,
    allProfiles,
    setProfile,
    setAdminProfile,
    setAllProfiles,
    setIsChangeLockChannel,
    isChangeLockChannel,
    setSelectedChannel,
    setChannelItems
  } = useContext(SessionContext);
  let { profileCode } = useParams();
  const history = useHistory();
  let query = useQuery();
  let page = query.get("page");
  let item = JSON.parse(localStorage.getItem("profile"));
  if (item?.pin) item.pin = window.atob(item.pin);
  let currentProfile = item;
  let pin = sessionStorage.getItem("pin");

  const normalizeProfileId = (value) => (value == null ? "" : String(value));
  const isSameProfileId = (a, b) =>
    normalizeProfileId(a) === normalizeProfileId(b);

  const getProfile = (id) => {
    let _allProfiles;
    if (allProfiles.length === 0) {
      _allProfiles = JSON.parse(localStorage.getItem("profiles"));
      if (_allProfiles) {
        setAllProfiles(_allProfiles);
      } else {
        return refreshProfiles(false);
      }
    } else {
      _allProfiles = allProfiles;
    }
    let profileData = _allProfiles.find((item) => isSameProfileId(item.id, id));
    if (profileData) {
      setSelectedProfile(profileData);
      // Normalize on the way in, so what the field shows is exactly what gets
      // saved back. Decoding at render time instead let the state keep a
      // mangled name and re-post it on the next save.
      setProfileName(normalizeApiText(profileData.name) || "");
      setProfileAvatar(profileData?.avatar || addProfileIcon);
      setIsChildProfile(profileData.kid);
      // Carry the avatar's own identity, never the profile's id -- that used to
      // be sent as the poster name on save, which the backend could not resolve,
      // so editing just the name silently reset the picture to the default.
      setSelectedAvatar({
        id: profileData?.avatarUid,
        posterName: profileData?.posterName,
        imageUrl: profileData?.avatar
      });
    }
  };

  const loadProfileAvatars = async () => {
    try {
      const { data } = await getProfileAvatarsApi();
      const avatarList = Array.isArray(data?.Data) ? data.Data : [];
      if (avatarList.length > 0) {
        setAvatars(
          avatarList
            .map((item) => ({
              id: item?.UId,
              posterName: item?.Name,
              name: item?.Name,
              imageUrl: item?.ImageUrl
            }))
            .filter((item) => !!item?.imageUrl)
        );
      } else {
        setAvatars([]);
      }
    } catch (e) {
      setAvatars([]);
    }
  };

  const goBack = () => {
    if (!!page) {
      history.goBack();
    } else {
      history.push("/profiles/all");
    }
  };

  const isMainAccount = !!currentProfile?.main;
  const isEditingExistingProfile = profileCode !== "new";
  const isEditingAnotherProfile =
    selectedProfile &&
    currentProfile &&
    selectedProfile.id !== currentProfile.id;
  const canDeleteProfile =
    isMainAccount && isEditingExistingProfile && isEditingAnotherProfile;

  const hasExistingProfilePin = () => {
    return (
      selectedProfile?.hasPin === true ||
      selectedProfile?.hasPin === "1" ||
      selectedProfile?.hasPin === 1
    );
  };


  const refreshProfiles = async (_goBack = true) => {
    const data = await getProfilesApi();
    if (data.status === 200) {
      let profileData = data.data;
      setAllProfiles(profileData);
      localStorage.setItem("profiles", JSON.stringify(profileData));
      let item = profileData.find((el) => isSameProfileId(el.id, profile.id));
      if (item) {
        // Decode PIN if it exists in server data (though this is rare)
        if (item?.pin) {
          try {
            item.pin = window.atob(item.pin);
          } catch (e) {
            // PIN might already be decoded or invalid
          }
        }

        setProfile(item);
        // Also update localStorage profile to ensure consistency
        localStorage.setItem("profile", JSON.stringify({ ...item, pin: item.pin ? window.btoa(item.pin) : "" }));
      }
      if (currentProfile?.main) {
        setAdminProfile(item);
      }
      if (_goBack) {
        goBack();
      }
      if (currentProfile?.main) {
        setAdminProfile(item);
      }
      if (_goBack) {
        goBack();
      }
    }
  };

  const editAuthorityId = profilePinAuthority(selectedProfile, currentProfile, allProfiles, true);
  const getCurrentProfilePin = () => {
    if (existingPin) return existingPin;
    if (!isSameProfileId(editAuthorityId || selectedProfile?.id, profile?.id)) return "";
    if (profile?.pin) {
      return profile.pin;
    }

    if (currentProfile?.pin) {
      return currentProfile.pin;
    }

    return "";
  };
  /**
   * The avatar identifier the API expects. The picker hands back the avatar's
   * UId, while a profile loaded from the server only carries its posterName --
   * both are the avatar's own identity, so either is fine to send.
   */
  const getSelectedPosterName = () =>
    selectedAvatar?.id || selectedAvatar?.posterName || "";

  const saveProfile = async (isRemovePassword = false) => {
    const { id, hasPin } = selectedProfile;
    setShowRemovePasswordNotification(false);
    const shouldRemoveAllChannelLocks =
      isRemovePassword;
    if (!profileName) {
      setShowProfileNameAlert(true);
      return;
    }
    if (
      !shouldRemoveAllChannelLocks &&
      !(
        (hasPin && (password.length == 4 || !password)) ||
        (!hasPin && !!password && password.length === 4) ||
        (!hasPin && !password)
      )
    ) {
      setShowNotification(true);
      setNotificationText(localizationStrings.profile.pinLength);
      return;
    }
    try {
      const finalPinValue = shouldRemoveAllChannelLocks ? "" : password;
      const data = await updateProfile(
        id,
        profileName,
        finalPinValue,
        getSelectedPosterName(),
        isChildProfile,
        { removePin: shouldRemoveAllChannelLocks, currentPin: getCurrentProfilePin() }
      );

      if (data) {
        setNotificationText(localizationStrings.profile.changesSaved);
        setShowNotification(true);
        if (isSameProfileId(id, profile.id) && shouldRemoveAllChannelLocks) {
          const updatedProfile = {
            ...profile,
            hasPin: false,
            pin: ""
          };
          setProfile(updatedProfile);
          const profileForStorage = {
            ...updatedProfile,
            pin: ""
          };
          localStorage.setItem("profile", JSON.stringify(profileForStorage));
          setSelectedChannel((prev) => {
            if (!prev) return prev;

            return {
              ...prev,
              interactions: (prev.interactions || []).filter(
                (interaction) => interaction !== "CHANNEL_LOCK"
              ),
              islocked: "0",
              parentalUnlocked: true
            };
          });

          setChannelItems((prevState) => {
            if (!Array.isArray(prevState)) return prevState;

            return prevState.map((channel) => ({
              ...channel,
              interactions: (channel.interactions || []).filter(
                (interaction) => interaction !== "CHANNEL_LOCK"
              ),
              islocked: "0"
            }));
          });

          setIsChangeLockChannel(
            isChangeLockChannel
              ? isChangeLockChannel === "1"
                ? "2"
                : "1"
              : "1"
          );
        }

        if (
          isSameProfileId(id, profile.id) &&
          !shouldRemoveAllChannelLocks &&
          password
        ) {
          const updatedProfile = { ...profile, hasPin: true, pin: password };
          setProfile(updatedProfile);

          const profileForStorage = {
            ...updatedProfile,
            pin: window.btoa(password)
          };
          localStorage.setItem("profile", JSON.stringify(profileForStorage));
        }

        refreshProfiles(false);
      } else {
        setNotificationText(localizationStrings.profile.changesNotSaved);
        setShowNotification(true);
      }
    } catch (error) {
      console.error("[ProfileSettings] Error while saving profile:", error);
      setNotificationText(localizationStrings.profile.changesNotSaved);
      setShowNotification(true);
    }
  };

  const addNewProfile = async () => {
    if (createPending.current) return;
    if (profileName.trim().length < 3) {
      setShowProfileNameAlert(true);
      return;
    }
    if (password && password.length !== 4) {
      setNotificationText(localizationStrings.profile.pinLength);
      setShowNotification(true);
      return;
    }
    createPending.current = true;
    setIsCreating(true);
    try {
      const { data } = await addProfile(
        profileName.trim(),
        isChildProfile,
        password,
        getSelectedPosterName()
      );
      if (!data) throw new Error("Profile was not created");
      await refreshProfiles(false);
      history.push("/profiles/all");
    } catch (error) {
      if (error.createdProfileId) {
        try { await refreshProfiles(false); } catch (_) { /* Keep the created id even if refresh fails. */ }
        history.replace(`/profile/${error.createdProfileId}?page=1`);
        setNotificationText(copy.partialCreate);
      } else {
        setNotificationText(localizationStrings.profile.changesNotSaved);
      }
      setShowNotification(true);
    } finally {
      createPending.current = false;
      setIsCreating(false);
    }
  };

  //delete profile logic
  const handleDeleteProfile = () => {
    if (!canDeleteProfile) return;
    setShowDeleteNotification(true);
  };

  const confirmDeleteProfile = async () => {
    setShowDeleteNotification(false);
    if (!canDeleteProfile) return;
    await delProfile();
  };

  const cancelDeleteProfile = () => {
    setShowDeleteNotification(false);
  };

  //save profile logic
  const handleSaveProfile = () => {
    if (profileCode === "new") {
      if (!!password) {
        if (password === secondPassword) {
          addNewProfile();
        } else {
          setShowAlert(true);
        }
      } else {
        addNewProfile();
      }
    } else {
      if (!!password) {
        if (password === secondPassword) {
          saveProfile();
        } else {
          setShowAlert(true);
        }
      } else {
        saveProfile();
      }
    }
  };

  const delProfile = async () => {
    if (!canDeleteProfile) return;
    const { data } = await deleteProfile(profileCode);
    goBack();
  };

  const avatarItems = avatars?.map((item, index) => {
    return (
      <button
        type="button"
        aria-label={`${copy.avatar}: ${index + 1}`}
        aria-pressed={focusedAvatar?.id === item.id}
        key={item.id}
        className={`avatar-item ${
          focusedAvatar?.id == item?.id ? "selected" : null
        }`}
        onClick={() => {
          setFocusedAvatar(item);
        }}
      >
        <div className="border">
          <img src={item.imageUrl} alt="" />
        </div>
      </button>
    );
  });

  useEffect(() => {
    if (profileCode) {
      if (profileCode !== "new") {
        getProfile(profileCode);
      } else {
        setProfileAvatar(addProfileIcon);
        //setProfileAvatar(addProfileIcon);
      }
    } else {
      goBack();
    }
  }, [profileCode, userFrameConfig, allProfiles]);

  useEffect(() => {
    loadProfileAvatars();
  }, []);

  useEffect(() => {
    if (pin) {
      sessionStorage.removeItem("pin");
      if (isFirefox) {
        setPinText(pin.replace(/[0-9,•]/g, "•"));
        setSecondPinText(pin.replace(/[0-9,•]/g, "•"));
      }
      setExistingPin(pin);
    }
  }, [pin]);

  return (
    <section className="profile-container atlas-profiles">
      <div className="row">
        <div className="logo-wrapper">
          <img src={mainLogo} alt="Atlas" className="atlas-logo" />
        </div>
        <button
          type="button"
          className="close"
          onClick={() => {
            if (showAvatars) {
              setShowAvatars(false);
            } else {
              goBack();
            }
          }}
        >
          <ArrowLeftIcon />
          <span>{localizationStrings.back}</span>
        </button>
      </div>
      <header className="profiles-heading">
        <span className="profiles-eyebrow">{copy.eyebrow}</span>
        <h1>
          {showAvatars
            ? copy.avatars
            : profileCode === "new"
            ? copy.create
            : copy.edit}
        </h1>
        <p>
          {showAvatars
            ? copy.avatarsNote
            : profileCode === "new"
            ? copy.createNote
            : copy.editNote}
        </p>
      </header>
      <section className="profile-settings-container">
        {selectedProfile && !showAvatars ? (
          <div className="profile-settings-box">
            <div className="current-avatar-wrapper">
              <img
                src={profileAvatar}
                alt=""
                onError={() => setProfileAvatar(addProfileIcon)}
              />
              <button
                type="button"
                aria-label={copy.avatar}
                className="edit-icon"
                onClick={() => {
                  setFocusedAvatar(null);
                  setShowAvatars(true);
                }}
              >
                <ProfileEditIcon />
              </button>
            </div>
            <div className="form-wrapper">
              <form
                id="profileSettingsForm"
                onKeyDown={(e) => {
                  if (e.key === "Enter" && e.target.tagName === "INPUT") {
                    e.preventDefault();
                    if (profileCode === "new") {
                      if (!!password) {
                        if (password === secondPassword) {
                          addNewProfile();
                        } else {
                          setShowAlert(true);
                        }
                      } else {
                        addNewProfile();
                      }
                    } else {
                      if (!!password) {
                        if (password === secondPassword) {
                          saveProfile();
                        } else {
                          setShowAlert(true);
                        }
                      } else {
                        saveProfile();
                      }
                    }
                  }
                }}
              >
                <div className="form-group">
                  <div className="input-box">
                    <input
                      className="input-profile"
                      style={{ width: "100%" }}
                      autoComplete="off"
                      name="profileName"
                      id="profileName"
                      type="text"
                      value={profileName}
                      //placeholder={localizationStrings.profileName}
                      onChange={(e) => {
                        showProfileNameAlert && setShowProfileNameAlert(false);
                        setProfileName(e.target.value);
                      }}
                      maxLength="15"
                      required
                    />
                    <label htmlFor="profileName">
                      {localizationStrings.profileName}
                    </label>
                  </div>
                  {showProfileNameAlert ? (
                    <div className="alert-text">
                      {localizationStrings.profileNameWarning}
                    </div>
                  ) : null}
                </div>
                {editAuthorityId && <div className="form-group">
                  <label htmlFor="existing-profile-pin">{editAuthorityId !== selectedProfile?.id ? copy.parentPin : copy.currentPin}</label>
                  <input id="existing-profile-pin" type="password" inputMode="numeric" maxLength={4}
                    autoComplete="off" value={existingPin} onChange={e => setExistingPin(e.target.value.replace(/\D/g, ""))} />
                </div>}
                <div className="form-group">
                  <div className="input-box">
                    {!isFirefox ? (
                      <input
                        onKeyDown={(e) =>
                          ["e", "E", "+", "-", ".", ","].includes(e.key) &&
                          e.preventDefault()
                        }
                        className="input-profile pin"
                        style={{ width: "100%" }}
                        autoComplete="off"
                        name="profileName"
                        id="first-pin"
                        type="number"
                        value={password}
                        //placeholder={`${localizationStrings.login.pin} (${localizationStrings.optional})`}
                        onChange={(e) => {
                          if (e.target.value.length > 4) {
                            e.target.value = e.target.value.slice(0, 4);
                          }
                          setPassword(e.target.value);
                          if (
                            e.target.value?.length <= secondPassword?.length &&
                            e.target.value !== secondPassword
                          ) {
                            setShowAlert(true);
                          } else {
                            setShowAlert(false);
                          }
                        }}
                      />
                    ) : (
                      <input
                        style={{ width: "100%" }}
                        className="input-profile pin"
                        autoComplete="off"
                        name="profileName"
                        id="first-pin"
                        type="text"
                        onMouseUp={(e) => {
                          let [pin, i] = firefoxPinSecret(null, e);
                          setI(i);
                          setPinText(pin.replace(/[0-9,•]/g, "•"));
                          setPassword(pin);
                        }}
                        onKeyDown={(e) => {
                          let [pin, i] = firefoxPinSecret(e, null);
                          setI(i);
                          setPinText(pin.replace(/[0-9,•]/g, "•"));
                          setPassword(pin);
                          if (
                            pin?.length <= secondPassword?.length &&
                            pin !== secondPassword
                          ) {
                            setShowAlert(true);
                          } else {
                            setShowAlert(false);
                          }
                        }}
                        onChange={(e) => {
                          e.target.value = pinText;
                          e.target.selectionEnd = i;
                          e.target.selectionStart = i;
                        }}
                        //value={password.replace(/[0-9]/g, "•")}
                        //placeholder={`${localizationStrings.login.password} (${localizationStrings.optional})`}
                      />
                    )}
                    <label htmlFor="first-pin">
                      {`${localizationStrings.login.pin} (${localizationStrings.optional})`}
                    </label>
                  </div>
                </div>

                <div className="form-group">
                  <div className="input-box">
                    {!isFirefox ? (
                      <input
                        className="input-profile pin"
                        style={{ width: "100%" }}
                        autoComplete="off"
                        name="profileName"
                        id="second-pin"
                        type="number"
                        maxLength="4"
                        value={secondPassword}
                        //placeholder={`${localizationStrings.login.pin} (${localizationStrings.again})`}
                        onKeyDown={(e) =>
                          ["e", "E", "+", "-", ".", ","].includes(e.key) &&
                          e.preventDefault()
                        }
                        onChange={(e) => {
                          if (e.target.value.length > 4) {
                            e.target.value = e.target.value.slice(0, 4);
                          }
                          setSecondPassword(e.target.value);
                          if (
                            password?.length <= e.target.value?.length &&
                            password !== e.target.value
                          ) {
                            setShowAlert(true);
                          } else {
                            setShowAlert(false);
                          }
                        }}
                      />
                    ) : (
                      <input
                        className="input-profile pin"
                        style={{ width: "100%" }}
                        autoComplete="off"
                        name="profileName"
                        id="second-pin"
                        type="text"
                        onMouseUp={(e) => {
                          let [pin, i] = firefoxPinSecret(null, e);
                          setSecondI(i);
                          setSecondPinText(pin.replace(/[0-9,•]/g, "•"));
                          setSecondPassword(pin);
                        }}
                        onKeyDown={(e) => {
                          let [pin, i] = firefoxPinSecret(e, null);
                          setSecondI(i);
                          setSecondPinText(pin.replace(/[0-9,•]/g, "•"));
                          setSecondPassword(pin);

                          if (
                            password?.length <= secondPassword?.length &&
                            secondPassword !== password
                          ) {
                            setShowAlert(true);
                          } else {
                            setShowAlert(false);
                          }
                        }}
                        onChange={(e) => {
                          e.target.value = secondPinText;
                          e.target.selectionEnd = secondI;
                          e.target.selectionStart = secondI;
                        }}
                        //value={secondPassword.replace(/[0-9]/g, "•")}
                        // placeholder={`${localizationStrings.login.password} (${localizationStrings.again})`}
                      />
                    )}
                    <label htmlFor="second-pin">
                      {`${localizationStrings.login.pin} (${localizationStrings.again})`}
                    </label>
                  </div>
                  {showAlert ? (
                    <div className="alert-text">
                      {localizationStrings.passwordsMatch}
                    </div>
                  ) : null}
                </div>
                {/* <div className="form-group">
                  <div className="kid-checkbox-row">
                    <div
                      className={`kid-checkbox ${
                        isChildProfile ? "checked" : ""
                      }`}
                      onClick={() => {
                        setSelectedAvatar(null);
                        setProfileAvatar(addProfileIcon);
                        setIsChildProfile(!isChildProfile);
                      }}
                    ></div>
                    <label htmlFor="kid-switch"><strong>{localizationStrings.kidsProfile}</strong><small>{copy.kidsNote}</small></label>
                  </div>
                </div> */}

                <div className="form-button-group">
                  <button
                    type="button"
                    className="yellow-button"
                    onClick={handleSaveProfile}
                  >
                    {localizationStrings.saveProfile}
                  </button>

                  {canDeleteProfile ? (
                    <button
                      type="button"
                      className="white-button"
                      onClick={handleDeleteProfile}
                    >
                      {localizationStrings.profile.delete}
                    </button>
                  ) : null}
                </div>
                {showNotification ? (
                  <Notification
                    text={notificationText}
                    confirmText={localizationStrings.close}
                    onClickConfirm={() => {
                      setShowNotification(false);
                      refreshProfiles(false);
                      history.push("/profiles/all");
                    }}
                  />
                ) : null}

                {showDeleteNotification && (
                  <Notification
                    text={localizationStrings.profile.deleteConfirmText}
                    confirmText={localizationStrings.yes}
                    notConfirmText={localizationStrings.no}
                    onClickConfirm={confirmDeleteProfile}
                    onClickNotConfirm={cancelDeleteProfile}
                    switchButtons={true}
                  />
                )}
                {profileCode !== "new" &&
                selectedProfile?.hasPin &&
                (currentProfile?.main || !selectedProfile?.kid) ? (
                  <div
                    className="form-buton-group"
                    style={{ marginTop: "1vw" }}
                    onClick={() => setShowRemovePasswordNotification(true)}
                  >
                    <button type="button" className="white-button">
                      <TvLockIcon />
                      {localizationStrings.removeProfilePassword}
                    </button>
                  </div>
                ) : null}
              </form>
            </div>
          </div>
        ) : profileCode === "new" && !showAvatars ? (
          <div className="create-profile-wrapper">
            <div className="new-profile-settings-box">
              <div className="new-profile-avatar">
                {profileAvatar === addProfileIcon ? (
                  <span className="profile-avatar-placeholder">
                    <CinemaIcon name="user" />
                  </span>
                ) : (
                  <img
                    src={profileAvatar}
                    alt=""
                    onError={() => setProfileAvatar(addProfileIcon)}
                  />
                )}
                <button
                  type="button"
                  aria-label={copy.avatar}
                  className="edit-icon"
                  onClick={() => {
                    setFocusedAvatar(null);
                    setShowAvatars(true);
                  }}
                >
                  <ProfileEditIcon />
                </button>
              </div>
              <form
                className="new-profile-form-wrapper"
                onSubmit={(event) => {
                  event.preventDefault();
                  addNewProfile();
                }}
              >
                <div className="input-box">
                  <input
                    className="input-profile"
                    style={{ width: "100%" }}
                    autoComplete="off"
                    name="profileName"
                    id="profileName"
                    type="text"
                    value={profileName}
                    //placeholder={localizationStrings.profileName}
                    onChange={(e) => {
                      showProfileNameAlert && setShowProfileNameAlert(false);
                      setProfileName(e.target.value);
                    }}
                    maxLength="15"
                    required
                  />
                  <label htmlFor="profileName">
                    {localizationStrings.name}
                  </label>
                </div>
                {showProfileNameAlert ? (
                  <div className="alert-text">
                    {localizationStrings.profileNameWarning}
                  </div>
                ) : null}
                <div className="child-profile-switch">
                  <label htmlFor="kid-switch">
                    <strong>{localizationStrings.kidsProfile}</strong>
                    <small>{copy.kidsNote}</small>
                  </label>
                  <SwitchButton
                    checked={isChildProfile}
                    id={"kid-switch"}
                    inputClass={"kid-switch"}
                    onChange={() => {
                      setSelectedAvatar(null);
                      setProfileAvatar(addProfileIcon);
                      setIsChildProfile(!isChildProfile);
                    }}
                  />
                </div>
                <button
                  type="submit"
                  className="yellow-button profile-create-action"
                  disabled={isCreating}
                >
                  {isCreating
                    ? localizationStrings.loading || "Loading…"
                    : localizationStrings.profile.createAProfile}
                </button>
              </form>
            </div>
          </div>
        ) : showAvatars ? (
          <div className="avatar-wrapper">
            <div
              className="avatar-box"
              style={{ marginTop: isChildProfile ? "7.85vw" : "" }}
            >
              {avatarItems}
              {!avatars.length && (
                <div className="profile-avatar-empty">
                  <p>{copy.avatarEmpty}</p>
                  <button
                    type="button"
                    className="white-button"
                    onClick={loadProfileAvatars}
                  >
                    {copy.retry}
                  </button>
                </div>
              )}
            </div>
            <div className="save-button">
              <button
                type="button"
                className="yellow-button"
                onClick={() => {
                  // Only replace the avatar if one was actually picked --
                  // confirming without choosing must leave it as it was.
                  if (focusedAvatar) {
                    setSelectedAvatar(focusedAvatar);
                    setProfileAvatar(focusedAvatar.imageUrl || addProfileIcon);
                  }
                  setShowAvatars(false);
                }}
              >
                {localizationStrings.profile.save}
              </button>
            </div>
          </div>
        ) : null}

        {/* {showNotification ? (
          <Notification
            text={notificationText}
            confirmText={localizationStrings.close}
            onClickConfirm={() => setShowNotification(false)}
          />
        ) : null} */}

        {profileCode === "new" && showNotification && (
          <Notification
            text={notificationText}
            confirmText={localizationStrings.close}
            onClickConfirm={() => setShowNotification(false)}
          />
        )}
        {showRemovePasswordNotification ? (
          <Notification
            text={localizationStrings.removeProfilePasswordText}
            confirmText={localizationStrings.yes}
            notConfirmText={localizationStrings.cancel}
            onClickConfirm={() => saveProfile(true)}
            onClickNotConfirm={() => setShowRemovePasswordNotification(false)}
          />
        ) : null}
      </section>
      {/* <div className="profile-gradient"></div>
      <div className="profile-gradient-2"></div> */}
    </section>
  );
};

export default ProfileSettings;
